import React from 'react'
import Websocket from 'react-websocket'
import {withRouter, Link} from 'react-router-dom'
import {Badge, ListGroup, ListGroupItem, Col, UncontrolledAlert} from 'reactstrap'
import Loader from 'react-loader-spinner'
import {WS_URL} from '../../../api'
import {provisioningHelpers} from '../../../dataHelpers'
import {Team} from '../../../models'
import {ErrorModal, ProvisionTeamForm, InfoAlert} from '../../ui'
import {pageHelpers} from '../'
import '../../../stylesheets/Provision.css'
import CreateTeamIcon from 'react-icons/lib/fa/user-plus'
import CreateDealerIcon from 'react-icons/lib/fa/building-o'

const CUSTOMER_TEAM_CREATION_INFO_ALERT_KEY = "customer_team_creation_info_alert_1"
const DEALER_TEAM_CREATION_INFO_ALERT_KEY = "dealer_team_creation_info_alert_1"

class CreatePage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {isSupport, provisionAsDealer, token} = props

        let initialEmail = ''
        let initialControllers = []
        if (this.queryParams.email) {
            initialEmail = this.queryParams.email
        }
        if (this.queryParams.controllers) {
            initialControllers = this.queryParams.controllers.split(',')
        }

        this.state = {
            token,
            provisionAsDealer,
            isSupport,
            initialEmail,
            initialControllers,
            errors: [],
            loading: false,
            provisionedTeams: [],
            adminEmails: []
        }

        this.searchForControllers = this.searchForControllers.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchProvisionedTeamsState = this.fetchProvisionedTeamsState.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {isSupport, provisionAsDealer, token} = nextProps
        pageHelpers.setupPropsForPage(nextProps, this)

        if (this.queryParams.email || this.queryParams.controllers) {
            let initialEmail = this.queryParams.email
            let initialControllers = []
            if (this.queryParams.controllers) {
                initialControllers = this.queryParams.controllers.split(',')
            }
            this.setState({initialEmail, initialControllers})
        }

        this.setState({
            provisionAsDealer,
            isSupport,
            token,
        })
    }

    async searchForControllers(query) {
        let {token, isSupport} = this.state
        let teamID = (isSupport ? null : this.user.activeTeam)
        let results = await provisioningHelpers.searchSerialNumber(token, query, true, isSupport, true, teamID)
        if (results.error) {
            this.setState({errors: [results.error]})
            return []
        }
        return results.map((r) => r.controller.serialNumber)
    }

    async fetchProvisionedTeamsState() {
        let {provisionedTeams, token} = this.state
        for (let i = 0; i < provisionedTeams.length; i++) {
            let team = provisionedTeams[i]
            let response = await provisioningHelpers.getTeam(token, team.id)
            if (!response.error && response.team) {
                provisionedTeams[i] = response.team
            }
        }
        this.setState({provisionedTeams})
    }

    async submitForm(teamName, adminEmail, controllerSerials, dealership) {
        this.setState({loading: true})
        let {token} = this.state
        let response = await provisioningHelpers.createTeam(token, teamName, adminEmail, controllerSerials, dealership)
        if (!response) {
            this.setState({loading: false})
        } else if (response.error) {
            this.setState({errors: [response.error]})
        } else {
            let newProvisionedTeam = response.team
            let newAdminEmail = response.adminEmail
            let {provisionedTeams, adminEmails} = this.state
            provisionedTeams.push(newProvisionedTeam)
            adminEmails.push(newAdminEmail)
            this.setState({provisionedTeams, adminEmails, loading: false, initialControllers: []})
            this.history.push(this.location.pathname)
        }
    }

    handleWebSocketResponse(data) {
        let {provisionedTeams} = this.state
        let result = JSON.parse(data)
        let updatedTeam = Team.fromAPIObject(result)
        let filteredTeams = provisionedTeams.filter((team) => team.id !== updatedTeam.id)
        if (filteredTeams.length < provisionedTeams.length) {
            let provisionedTeams = filteredTeams
            provisionedTeams.push(updatedTeam)
            this.setState({provisionedTeams})
        }
    }

    render() {
        let {loading, provisionedTeams, adminEmails, errors, provisionAsDealer, initialEmail, isSupport, token,
             initialControllers} = this.state
        let teamsVisible = (provisionAsDealer ? "Dealer" : "Customer")
        let teamsVisibleURL = (provisionAsDealer ? "dealers" : "customers")
        let infoAlertKey = (provisionAsDealer ? DEALER_TEAM_CREATION_INFO_ALERT_KEY : CUSTOMER_TEAM_CREATION_INFO_ALERT_KEY)
        let infoAlertBody = (provisionAsDealer ?
                                "A dealer must have a dealer team before they can assign Marksman controllers to customers. ":
                                "A customer must be part of a team before they can view and control their Marksman controllers. ")

        return <Col xs={12} className="align-content-center align-items-center no-gutters">
            {this.user && this.user.isSupport && !isSupport ?
                <UncontrolledAlert color="warning">
                    This is the Dealer view of the Create {teamsVisible} Team Page. Support users should only use this for demonstration.
                </UncontrolledAlert> :
                null}
            <h1 className="col-12 no-gutters d-block d-sm-none light-sf-orange font-weight-bold">
                {provisionAsDealer ?
                    <CreateDealerIcon className="light-sf-blue mr-2"/> :
                        <CreateTeamIcon className="light-sf-blue mr-2"/>}
                Create {teamsVisible} Team
            </h1>
            <h1 className="col-12 no-gutters mb-2 d-none d-sm-block light-sf-orange font-weight-bold">
                {provisionAsDealer ?
                    <CreateDealerIcon className="light-sf-blue mr-2"/> :
                        <CreateTeamIcon className="light-sf-blue mr-2"/>}
                Create a New {teamsVisible} Team
            </h1>
            <p className="col-12 mb-4">
                {isSupport ?
                    <Link className="light-sf-blue" to={`/management/teams/${teamsVisibleURL}`}>or see existing {teamsVisible} teams.</Link>:
                        null}
            </p>
            <InfoAlert
                header={`Creating ${teamsVisible} Teams`}
                body={infoAlertBody + "To create a team, we need a team name and email address for the first user with 'Manage Team' permissions. You can also specify a few controllers to assign to the new team. After the team is created, The team administrator should receive an email to finish setting up their account."}
                alertKey={infoAlertKey}/>
            {loading ?
                <Col xs={12} className="no-gutters text-center m-4">
                    <Loader type="TailSpin" color="orange" width={60} height={60}/>
                </Col>:
                    <ProvisionTeamForm
                        searchForControllers={(query) => this.searchForControllers(query)}
                        controllers={initialControllers}
                        email={initialEmail}
                        isSupport={isSupport}
                        onSubmit={(teamName, email, serials) => this.submitForm(teamName, email, serials, provisionAsDealer)}/>}
            {provisionedTeams.length > 0 ?
                <Col xs={12} id="provisioned-teams" className="">
                    <h3 className="col-12">Provisioned Teams</h3>
                    <ListGroup>
                        {provisionedTeams.map((team, idx) => (
                            <ListGroupItem key={idx}>
                                <Badge color="success" pill>Created</Badge>
                                &emsp;

                                <strong>Name:&ensp;</strong>
                                {team.name}
                                &ensp;&mdash;&ensp;

                                <strong>Admin:&ensp;</strong>
                                &emsp;&emsp;
                                {adminEmails[idx] ?
                                    adminEmails[idx] :
                                        null}

                                {token ?
                                    <Websocket
                                        url={`${WS_URL}/teams/${team.id}/?access_token=${token.accessToken}`}
                                        onMessage={this.handleWebSocketResponse}/> :
                                        null}
                            </ListGroupItem>))}
                    </ListGroup>
                </Col>:
                    null}
            {pageHelpers.renderErrorModalsForPage(errors, this)}
        </Col>
    }
}

export default withRouter(CreatePage)



// WEBPACK FOOTER //
// ./src/components/pages/teams/CreatePage.js